// extracted by mini-css-extract-plugin
export default {"ScreenXXSMax":"(max-width: 543px)","button":"G88d6fa","copy":"Gfc92bc G519ebe"};